import React, { useEffect, useState } from 'react';
import './Footer.css'
import { Link as Anchor } from 'react-router-dom';
import { API_ENDPOINTS } from '../../config/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

export default function Footer() {
    const [tienda, setTienda] = useState({});
    const [categorias, setCategorias] = useState([]);

    useEffect(() => {
        cargarCategorias();
        cargarTienda();
    }, []);

    const cargarCategorias = () => {
        fetch(API_ENDPOINTS.categorias, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(data => {
                // Mezclar las categorías aleatoriamente
                const shuffledCategorias = data.categorias?.sort(() => 0.5 - Math.random());
                // Tomar las primeras 3 categorías de las mezcladas
                setCategorias(shuffledCategorias.slice(0, 3));
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };

    const cargarTienda = () => {
        fetch(API_ENDPOINTS.tiendas, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(data => {
                // Intentar diferentes formatos de respuesta
                const tiendasArray = data?.tiendas || data?.tienda || [];
                const tiendaData = Array.isArray(tiendasArray) 
                    ? (tiendasArray[0] || {})
                    : (tiendasArray || {});
                setTienda(tiendaData);
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };

    return (
        <div className='FooterContain'>
            <div className='footerText' id='footerText'>
                <Anchor to='/'>
                    {tienda?.imagen1 ? (
                        <img src={tienda?.imagen1_url || tienda?.imagen1} alt="logo" />
                    ) : (
                        <></>
                    )}
                </Anchor>

                {tienda?.nombre ? (
                    <h2>{tienda?.nombre}</h2>
                ) : (
                    <h2>Sistema</h2>
                )}
                {tienda?.eslogan ? (
                    <span>{tienda?.eslogan}</span>
                ) : (
                    <span>Eslogan</span>
                )}
            </div>

            <div className='footerText'>
                <h3>Contacto </h3>
                <Anchor to={`https://www.google.com/maps?q=${encodeURIComponent(tienda.direccion)}`} target="_blank">{tienda.direccion}</Anchor>
                <Anchor to={`mailto:${tienda.email}`} target="_blank">{tienda.email}</Anchor>
                <div className='socials'>
                    <Anchor to={tienda.instagram} target="_blank"><i className='fa fa-instagram'></i></Anchor>
                    <Anchor to={`tel:${tienda.telefono}`} target="_blank"><i className='fa fa-whatsapp'></i></Anchor>
                    <Anchor to={tienda.facebook} target="_blank"><i className='fa fa-facebook'></i></Anchor>
                </div>
            </div>

            <div className='footerText'>
                <h3>Categorias</h3>
                {
                    categorias?.map((item, index) => (
                        <Anchor key={index} >{item.categoria}</Anchor>
                    ))
                }
            </div>

            <div className='footerText'>
                <h3>Acceso</h3>
                <Anchor to={`/dashboard`} className='btnAnch'>
                    <FontAwesomeIcon icon={faUser} /> Dashboard
                </Anchor>
            </div>
        </div>
    );
}
